import React, { Fragment } from 'react';

import {
  FetchMaterialsCacheKeys,
  UpdateMaterialCacheAction
} from '../../../../../../materials/materialsTypes';
import {
  UpdateMaterialsSetCacheAction,
  FetchMaterialsSetsCacheKeys
} from '../../../../../../materialsSets/materialsSetsTypes';
import {
  ThreeDStockMaterialsListLightboxBottomButtonsMaterial,
  ThreeDStockMaterialsListLightboxBottomButtonsMaterialsSet
} from './ThreeDStockMaterialsListLightboxBottomButtons.types';

import { ThreeDStockMaterialsListLightboxSelectButton } from '../ThreeDStockMaterialsListLightboxSelectButton';

interface ThreeDStockMaterialsListLightboxBottomButtonsDefaultProps {
  material: ThreeDStockMaterialsListLightboxBottomButtonsMaterial;
  materialsCacheKeys?: FetchMaterialsCacheKeys;
  updateMaterialCache?: UpdateMaterialCacheAction<ThreeDStockMaterialsListLightboxBottomButtonsMaterial>;
}

interface ThreeDStockMaterialsListLightboxBottomButtonsWithSelectProps {
  materialsSet: ThreeDStockMaterialsListLightboxBottomButtonsMaterialsSet | null;
  materialsSetCacheKeys?: FetchMaterialsSetsCacheKeys;
  updateMaterialsSetCache: UpdateMaterialsSetCacheAction<ThreeDStockMaterialsListLightboxBottomButtonsMaterialsSet>;
}

interface ThreeDStockMaterialsListLightboxBottomButtonsWithoutProps {
  materialsSet?: never;
  materialsSetCacheKeys?: never;
  updateMaterialsSetCache?: never;
}

type ThreeDStockMaterialsListLightboxBottomButtonsProps =
  ThreeDStockMaterialsListLightboxBottomButtonsDefaultProps &
    (
      | ThreeDStockMaterialsListLightboxBottomButtonsWithSelectProps
      | ThreeDStockMaterialsListLightboxBottomButtonsWithoutProps
    );

function ThreeDStockMaterialsListLightboxBottomButtons({
  material,
  materialsSet,
  materialsSetCacheKeys,
  updateMaterialsSetCache
}: ThreeDStockMaterialsListLightboxBottomButtonsProps) {
  return (
    <Fragment>
      <ThreeDStockMaterialsListLightboxSelectButton
        material={material}
        materialsSet={materialsSet}
        materialsSetCacheKeys={materialsSetCacheKeys}
        updateMaterialsSetCache={updateMaterialsSetCache}
      />
    </Fragment>
  );
}

export default ThreeDStockMaterialsListLightboxBottomButtons;
